/**
 * Rounds a count of "partial bins" to the appropriate decimal places.
 */
export function roundBins(bins: number): number {
  return parseFloat(bins.toFixed(2));
}
